/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'APPROPRIATE_BEHAVIOR_AMONG_BETWEEN_WORKERS_MANAGEMENT_SUPERVISO',
              'APPROPRIATE_BEHAVIOR_BY_SECURITY_GUARDS_IF_APPLICABLE_',
              'VIOLENCE_AND_HARASSMENT_IN_THE_WORKPLACE',
              'ANTI_DISCRIMINATION',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_3: valueSchema,
  },
}
